export default (typeof window !== 'undefined' ? window.__ENV__ : process.env);



// WEBPACK FOOTER //
// lib/env.js